exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select-empty-error {\r\n    border: dashed 2px red !important;\n}\n.criterion-main, .criterion-main a {\r\n    background-color: var(--primary-to-yellow);\r\n    color: #fff;\n}\r\n\r\n", ""]);

// exports
